export default "/fonts/vendor/socicon/socicon.svg?d1edd88f5dd84572d00d09b1912193db";